import type { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

export function AgentTabSurface({
  title,
  description,
  actions,
  children,
  className,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={cn("flex min-h-0 flex-1 flex-col bg-[var(--bg-subtle)]", className)}>
      <header className="flex shrink-0 flex-wrap items-start justify-between gap-3 py-4">
        <div className="min-w-0">
          <h3 className="text-base font-semibold leading-6" style={{ color: "var(--text-strong)" }}>
            {title}
          </h3>
          {description ? (
            <p className="mt-1 max-w-3xl text-sm leading-5" style={{ color: "var(--muted-foreground)" }}>
              {description}
            </p>
          ) : null}
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </header>
      <div className="min-h-0 flex-1 pb-4">{children}</div>
    </section>
  );
}
